<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <base-dropdown v-if="activeModules.length > 0">
                <base-button slot="title" type="warning" class="dropdown-toggle">
                    {{_.startCase(reportName)}} - {{_.startCase(currentProfile)}}
                </base-button>
                <a v-for="profile in activeModules" :key="profile.id"
                    @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)"
                    class="dropdown-item" href="#">{{profile.name}}</a>
            </base-dropdown>
            <base-dropdown v-else>
                <base-button slot="title" type="primary" class="dropdown-toggle">
                    {{reportName}}
                </base-button>
                <a class="dropdown-item" disabled>No active module/s under this feature</a>
            </base-dropdown>
        </base-header>
        <!-- <img style="display: none;" id='reportLogo' :src="imagepath" alt='Report Logo' crossorigin="anonymous"/> -->
        <div id="logoDiv" style="display: none;"></div>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <operations-report :friendlyCode="friendlyCode"></operations-report>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import OperationsReport from '../Basic Operations Reports/OperationsReport';
    import {
        mapState,
        mapActions
    } from 'vuex'

    export default {
        data() {
            return {
                imagepath: secureStorage.getItem("account_logo"),
                reportName: 'Inventory Adjustment Operations Reports',
                activeModules: [],
                accessRights: [],
                componentKey: 0,
                friendlyCode: '',
                transOptions: [
                    // {key: "", value: "pos_activity_reports"},
                   
                    {key: "RECADJ", value: "adjustment_in_journals"},
                    {key: "RELADJ", value: "adjustment_out_journals"},
                    {key: "OTHPCN", value: "physical_count_journals"},
                    {key: "OTHASM", value: "assemble_journals"},
                    {key: "OTHDSM", value: "disassemble_journals"},

                ],
            }
        },
        mounted: async function () {
            //Fix: S3 image CORS error in jsPDF
            const corsImageModified = new Image();
            corsImageModified.crossOrigin = "Anonymous";
            corsImageModified.id = "reportLogo";
            corsImageModified.src = secureStorage.getItem("account_logo") + "?not-from-cache-please";
            document.getElementById("logoDiv").appendChild(corsImageModified);
            //Fix: S3 image CORS error in jsPDF
            
            this.updateOperationsReport()
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components: {
            OperationsReport

        },
        methods: {
            ...mapActions(['updateCurrentProfile', 'updateParameters']),
            async setCurrentProfile(profile, id) {
                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
                if (_.isEmpty(accessRightsRequest.access_rights) == false){
                    this.accessRights = accessRightsRequest.access_rights[id]
                }else {
                    this.accessRights = []
                }

                this.updateCurrentProfile(profile);
                this.friendlyCode = this.transOptions.find(x => x.value == this.currentProfile).key
            },
            
            async updateOperationsReport(){
                this.activeModules = []
                let code = this.$route.params.code
                console.log(this.$route.params)
                var component_x = this;

                var categoryId = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories?code=R-007&status=A', null, null)
                if(categoryId[0] != undefined){
                    this.reportName = categoryId[0].name
                    component_x.activeModules = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories/' + categoryId[0].id + '/enabled_modules?account_smcs_id=' + categoryId[0].account_smcs_id, null, null)
                    if (component_x.activeModules.length > 0) {
                        var profile = _.snakeCase(component_x.activeModules[0].name)
                        component_x.setCurrentProfile(_.pluralize(profile), component_x.activeModules[0].id);
                    } else {
                        component_x.setCurrentProfile(null, null);
                    }
                }

                this.componentKey+= 1;
            }
        },

        watch: {
            "$route.params.code"(to, from){
                if(to !== from){
                    this.updateOperationsReport()
                }
            }
        }

    };
</script>

<style></style>